import { useState } from "react";
import {
  MODIFY_CATALOG_LABELS,
  MODIFY_PRODUCT_TAGS,
  SELECT_A_OPTION,
} from "../../../../i18n/keysTranslations";
import Select from "../../../Form/Select";
import { useController, useForm } from "react-hook-form";
import ModalCatalogLabels from "./ModalCatalogLabels/ModalCatalogLabels";
import ModalProductTags from "./ModalProductTags/ModalProductTags";
import { useTranslationApp } from "../../../../lib/i18next";

const EditCreativeTools = ({
  disabled,
  control,
  name,
  onActionChange,
  disableProductTagsOption,
  sxTextField = {},
}) => {
  const { t } = useTranslationApp();
  const {
    field: { value: valueField = {}, onChange: onChangeField },
  } = useController({
    name,
    control,
    defaultValue: {},
  });
  const { control: controlModal } = useForm({
    defaultValues: {
      value: "",
    },
  });
  const [modalCatalogLabels, setModalCatalogLabels] = useState(false);
  const [modalProductTags, setModalProductTags] = useState(false);

  const getOptions = () => {
    const basicOptions = [
      {
        value: "catalogLabels",
        label: MODIFY_CATALOG_LABELS,
      },
    ];
    if (!disableProductTagsOption) {
      basicOptions.push({
        value: "productTags",
        label: MODIFY_PRODUCT_TAGS,
      });
    }
    return basicOptions;
  };

  return (
    <>
      <Select
        disabled={disabled}
        placeholder={t(SELECT_A_OPTION)}
        displayEmpty
        showEmptyOption
        variant="filled"
        doTranslate={true}
        control={controlModal}
        name={"value"}
        useOnChange={false}
        actionsChange={(value) => {
          if (value === "catalogLabels") {
            setModalCatalogLabels(true);
          } else if (value === "productTags") {
            setModalProductTags(true);
          }
        }}
        options={getOptions()}
        sx={{
          ...sxTextField,
          "& .MuiSelect-select": {
            em: {
              fontStyle: "normal",
              position: "absolute",
              top: 22,
            },
          },
        }}
      />

      {modalCatalogLabels && (
        <ModalCatalogLabels
          modalOpen={modalCatalogLabels}
          onCloseModal={() => setModalCatalogLabels(false)}
          initialValues={valueField.catalogLabelsConfiguration || {}}
          onCallbackSave={(value) => {
            onChangeField({
              ...valueField,
              catalogLabelsConfiguration: value,
            });
            onActionChange();
          }}
        />
      )}

      {modalProductTags && (
        <ModalProductTags
          modalOpen={modalProductTags}
          onCloseModal={() => setModalProductTags(false)}
          onCallbackSave={(value) => {
            onChangeField({
              ...valueField,
              showProductTags: value,
            });
            onActionChange();
          }}
          initialValue={valueField.showProductTags}
        />
      )}
    </>
  );
};

export default EditCreativeTools;
